import React from 'react';
import {useTranslation} from "react-i18next";
import {Button, Layout, message} from "antd";
import {Outlet} from "react-router-dom";
import {TokenStorage} from "../../services/token.service";
import {signout} from "../../api/authApi";
import {clearProfile} from "../../reducers/profileReducer";
import {clearAuthState} from "../../reducers/authReducer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../reducers/reducer";
import {showMessage, showMessageWithTitle} from "../../common/message";

export const MainTemplate = () => {
  const {t} = useTranslation("common");
  const {authenticated} = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [messageApi, messageHolder] = message.useMessage();
  
  const logout = () => {
    const refresh = TokenStorage.getRefreshToken() || "";
    signout(refresh, () => {
      TokenStorage.clear();
      dispatch(clearProfile());
      dispatch(clearAuthState());
    }, () => {
      TokenStorage.clear();
      dispatch(clearProfile());
      dispatch(clearAuthState());
    });
    showMessage(messageApi, t("로그아웃됐습니다."), "success")
  }
  
  const handleLogout = () => {
    showMessageWithTitle(t("로그아웃을 계속 진행할까요?"), logout)
  };
  
  return (<Layout className={"h-screen"}>
    {messageHolder}
    <div className={"header flex justify-between"}>
      <div className={"text"}>{t("header")}</div>
      {authenticated &&
          <Button size={"middle"} type={"link"} className={"button"} onClick={handleLogout}>{t("logout")}</Button>}
    </div>
    <Layout>
      <Outlet />
    </Layout>
  </Layout>);
};
